var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2499 9.9109C22.7912 9.08966 20.9587 10.1609 20.6649 10.3459L14.3687 13.9171C13.4387 13.1784 12.1137 13.2096 11.22 13.9921C10.3262 14.7734 10.1187 16.0809 10.7262 17.1021C11.3337 18.1234 12.5837 18.5621 13.6962 18.1471C14.8087 17.7321 15.4662 16.5821 15.2587 15.4134L21.5374 11.8496L21.5774 11.8259C21.9899 11.5646 22.9474 11.1746 23.3949 11.4271C23.7174 11.6096 23.9011 12.2184 23.9161 13.1146H23.9086V20.9909C23.9074 21.7259 23.5161 22.4046 22.8799 22.7733L13.8524 27.9883C13.2149 28.3546 12.4312 28.3546 11.7949 27.9883L2.76749 22.7733C2.13124 22.4046 1.73999 21.7259 1.73874 20.9909V10.5659C1.73999 9.8309 2.13124 9.15216 2.76749 8.78466L10.9375 4.06968C11.7137 4.96093 13.0174 5.17218 14.0362 4.56968C15.0549 3.96968 15.5012 2.72594 15.0962 1.61594C14.6912 0.503445 13.5512 -0.160302 12.3849 0.0334474C11.2175 0.228447 10.3562 1.22719 10.3337 2.40969L1.90499 7.27842C0.727497 7.95591 0.00249999 9.20841 0 10.5659V20.9884C0.00124999 22.3459 0.723747 23.5983 1.89874 24.2771L10.925 29.4921C12.0999 30.1683 13.5462 30.1683 14.7212 29.4921L23.7486 24.2771C24.9211 23.5983 25.6449 22.3458 25.6474 20.9909V13.4134H25.6536C25.6961 11.6359 25.2199 10.4597 24.2499 9.9109Z",
    fill: "black"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.4073975424ba7a25653fde4ad7de4dd5.svg";
export { ForwardRef as ReactComponent };